import { render, staticRenderFns } from "./PriceAnalysisModal.vue?vue&type=template&id=63b12dc6&scoped=true&"
import script from "./PriceAnalysisModal.vue?vue&type=script&lang=js&"
export * from "./PriceAnalysisModal.vue?vue&type=script&lang=js&"
import style0 from "./PriceAnalysisModal.vue?vue&type=style&index=0&id=63b12dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b12dc6",
  null
  
)

export default component.exports